// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Catalog settings modal: values the user owns, read by agents at run time. */

.qYhBn4oaal0ZUi3fYItp {
  padding: 4px 8px 8px;
  min-width: 380px;
}

.JvBXpxNQZ5wvmrw12eQB {
  margin: 0 0 6px;
  font-size: 16px;
  font-weight: 600;
  color: var(--curio-text-primary);
}

.vLAtctbWtruXPrMFJJL5 {
  margin: 0 0 12px;
  font-size: 12px;
  line-height: 1.5;
  color: var(--curio-text-secondary, var(--curio-text-meta));
}

.kddOV0zrKTI4U8BhxdXU {
  margin: 0 0 12px;
  font-size: 12px;
  line-height: 1.5;
  color: var(--curio-text-primary);
  background: var(--curio-surface-muted);
  border: 1px solid var(--curio-border);
  border-radius: 10px;
  padding: 8px 10px;
}

.Y3JmmqMGOYYJhz2PebPr {
  border-top: 1px solid var(--curio-border);
  padding-top: 12px;
  margin-top: 4px;
}

.RZWxBxikE6pmTZ7xGUdX {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 4px;
  font-size: 14px;
  font-weight: 600;
  color: var(--curio-text-primary);
}

.rsqDnnuWL_uTQeCx8th1 {
  font-size: 11px;
  font-weight: 600;
  border: 1px solid var(--curio-border);
  border-radius: 999px;
  padding: 1px 8px;
  color: var(--curio-text-secondary);
}

.POsipiotohD8U343p5QT {
  margin: 0 0 10px;
  font-size: 12px;
  color: var(--curio-text-secondary, var(--curio-text-meta));
}

.n1yFhBzJmztSOzZAaMDU {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.n1yFhBzJmztSOzZAaMDU th {
  text-align: left;
  font-weight: 600;
  color: var(--curio-text-secondary);
  padding: 0 6px 6px 0;
}

.n1yFhBzJmztSOzZAaMDU td {
  padding: 0 6px 6px 0;
  vertical-align: top;
}

.hJrktvZkY65GkD0nGsWE {
  font-weight: 400;
}

.YpFjKwAbY0s_thQ696tR {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid var(--curio-border);
  border-radius: 8px;
  padding: 5px 8px;
  font: inherit;
  color: var(--curio-text-primary);
  background: var(--curio-card-bg);
}

.YpFjKwAbY0s_thQ696tR:read-only {
  background: var(--curio-surface-muted);
}

.Wb2XBQ_0JokQhXLF4nUK {
  border: 0;
  background: none;
  font-size: 16px;
  line-height: 1;
  padding: 4px 6px;
  color: var(--curio-text-secondary);
  cursor: pointer;
}

.Wb2XBQ_0JokQhXLF4nUK:hover {
  color: var(--curio-danger-text);
}

.CqQThpMsUcLI_jcxBR9Q {
  margin: 10px 0 0;
  font-size: 12px;
  color: var(--curio-danger-text);
  white-space: pre-wrap;
}

.du5Ia1BDgwzQ61GImbQ0,
.n3yzjzhi8SXWTFiL5drY {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
}

.n3yzjzhi8SXWTFiL5drY {
  justify-content: flex-end;
  margin-top: 16px;
}

.vN3hwW8pMvYQ9NiG7d1P {
  flex: 1;
}

.OxmZy_2xvBR5IEpNLHor {
  font-size: 12px;
  color: var(--curio-text-secondary);
}

.dBa6YlV7rc8cDJorvloM {
  border: 1px solid var(--curio-border);
  border-radius: 999px;
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 600;
  background: var(--curio-card-bg);
  color: var(--curio-text-primary);
  cursor: pointer;
}

.wbGQNz2vkq8Ae1syEPHz {
  border: none;
  border-radius: 999px;
  padding: 6px 18px;
  font-size: 12px;
  font-weight: 600;
  background: var(--curio-top-bar-bg);
  color: var(--curio-text-on-dark);
  cursor: pointer;
}

.dBa6YlV7rc8cDJorvloM:disabled,
.wbGQNz2vkq8Ae1syEPHz:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/components/agents/catalog/AgentCatalogSettingsModal.module.css"],"names":[],"mappings":"AAAA,8EAA8E;;AAE9E;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,0DAA0D;AAC5D;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,sCAAsC;EACtC,qCAAqC;EACrC,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;EACzC,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,oBAAoB;EACpB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;EAClC,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,gCAAgC;EAChC,eAAe;AACjB;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":["/* Catalog settings modal: values the user owns, read by agents at run time. */\n\n.body {\n  padding: 4px 8px 8px;\n  min-width: 380px;\n}\n\n.title {\n  margin: 0 0 6px;\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--curio-text-primary);\n}\n\n.hint {\n  margin: 0 0 12px;\n  font-size: 12px;\n  line-height: 1.5;\n  color: var(--curio-text-secondary, var(--curio-text-meta));\n}\n\n.notice {\n  margin: 0 0 12px;\n  font-size: 12px;\n  line-height: 1.5;\n  color: var(--curio-text-primary);\n  background: var(--curio-surface-muted);\n  border: 1px solid var(--curio-border);\n  border-radius: 10px;\n  padding: 8px 10px;\n}\n\n.setting {\n  border-top: 1px solid var(--curio-border);\n  padding-top: 12px;\n  margin-top: 4px;\n}\n\n.settingTitle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0 0 4px;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--curio-text-primary);\n}\n\n.badge {\n  font-size: 11px;\n  font-weight: 600;\n  border: 1px solid var(--curio-border);\n  border-radius: 999px;\n  padding: 1px 8px;\n  color: var(--curio-text-secondary);\n}\n\n.readers {\n  margin: 0 0 10px;\n  font-size: 12px;\n  color: var(--curio-text-secondary, var(--curio-text-meta));\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12px;\n}\n\n.table th {\n  text-align: left;\n  font-weight: 600;\n  color: var(--curio-text-secondary);\n  padding: 0 6px 6px 0;\n}\n\n.table td {\n  padding: 0 6px 6px 0;\n  vertical-align: top;\n}\n\n.fieldNote {\n  font-weight: 400;\n}\n\n.input {\n  width: 100%;\n  box-sizing: border-box;\n  border: 1px solid var(--curio-border);\n  border-radius: 8px;\n  padding: 5px 8px;\n  font: inherit;\n  color: var(--curio-text-primary);\n  background: var(--curio-card-bg);\n}\n\n.input:read-only {\n  background: var(--curio-surface-muted);\n}\n\n.remove {\n  border: 0;\n  background: none;\n  font-size: 16px;\n  line-height: 1;\n  padding: 4px 6px;\n  color: var(--curio-text-secondary);\n  cursor: pointer;\n}\n\n.remove:hover {\n  color: var(--curio-danger-text);\n}\n\n.error {\n  margin: 10px 0 0;\n  font-size: 12px;\n  color: var(--curio-danger-text);\n  white-space: pre-wrap;\n}\n\n.actions,\n.footer {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 12px;\n}\n\n.footer {\n  justify-content: flex-end;\n  margin-top: 16px;\n}\n\n.spacer {\n  flex: 1;\n}\n\n.saved {\n  font-size: 12px;\n  color: var(--curio-text-secondary);\n}\n\n.secondary {\n  border: 1px solid var(--curio-border);\n  border-radius: 999px;\n  padding: 6px 14px;\n  font-size: 12px;\n  font-weight: 600;\n  background: var(--curio-card-bg);\n  color: var(--curio-text-primary);\n  cursor: pointer;\n}\n\n.primary {\n  border: none;\n  border-radius: 999px;\n  padding: 6px 18px;\n  font-size: 12px;\n  font-weight: 600;\n  background: var(--curio-top-bar-bg);\n  color: var(--curio-text-on-dark);\n  cursor: pointer;\n}\n\n.secondary:disabled,\n.primary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": `qYhBn4oaal0ZUi3fYItp`,
	"title": `JvBXpxNQZ5wvmrw12eQB`,
	"hint": `vLAtctbWtruXPrMFJJL5`,
	"notice": `kddOV0zrKTI4U8BhxdXU`,
	"setting": `Y3JmmqMGOYYJhz2PebPr`,
	"settingTitle": `RZWxBxikE6pmTZ7xGUdX`,
	"badge": `rsqDnnuWL_uTQeCx8th1`,
	"readers": `POsipiotohD8U343p5QT`,
	"table": `n1yFhBzJmztSOzZAaMDU`,
	"fieldNote": `hJrktvZkY65GkD0nGsWE`,
	"input": `YpFjKwAbY0s_thQ696tR`,
	"remove": `Wb2XBQ_0JokQhXLF4nUK`,
	"error": `CqQThpMsUcLI_jcxBR9Q`,
	"actions": `du5Ia1BDgwzQ61GImbQ0`,
	"footer": `n3yzjzhi8SXWTFiL5drY`,
	"spacer": `vN3hwW8pMvYQ9NiG7d1P`,
	"saved": `OxmZy_2xvBR5IEpNLHor`,
	"secondary": `dBa6YlV7rc8cDJorvloM`,
	"primary": `wbGQNz2vkq8Ae1syEPHz`
};
export default ___CSS_LOADER_EXPORT___;
